import type { FaireProductEntity } from "../../entity_types/product";

export const p_buvkfjy5wj: FaireProductEntity = {
  token: "p_buvkfjy5wj",
  type: "product",
  name: "Baby, Toddler and Youth Custom Design Cotton Tee Shirt",
  brandToken: "b_8kumxdqk",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a7d1c9cfb562752ac9b2e1a6c543da4aeefac5b02c08a0f8883f32288a502d3f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81e0ce2797a9782ecb910fdb718dd76b584a6ee2040396722a0d05b66fe5347e.png",
    "https://cdn.faire.com/fastly/cefb96396745be1a9ee8e01feefa010ddab52b35fb5606580d021c251dd5c763.png",
    "https://cdn.faire.com/fastly/cd4eac17b6c185e5f20d0171b6832bf7d3f56b47ec5746097005f13f85440423.png",
    "https://cdn.faire.com/fastly/591925be5fb2d6f4d5224ed7ac5d1300fa7dcaa63c2fc058a0c6ba729ee1babf.png",
    "https://cdn.faire.com/fastly/6923418a2223e934199ba23b059409191d8548ed67772537b87b4ba57a6797f7.png",
    "https://cdn.faire.com/fastly/af7c95a71b5ad1d7330333ce6eef8f8bced4164597b53e87d4852c8621d90464.png",
    "https://cdn.faire.com/fastly/f2d4c36162800b720a75cab8f938dd9a8cb9053bc82d35b4216cf9ee79b5876b.png",
    "https://cdn.faire.com/fastly/2564888f9aa34abc553f1de94fb6247ef53a6a8217d47f48a8fb845a75e3bb1e.png",
    "https://cdn.faire.com/fastly/bb41035b8ce2abbe9c830619f3fbdbc6f829ebe0ef21e4fe11c8ceedc543c93f.png",
    "https://cdn.faire.com/fastly/dbd12da686b5014dc05ccf919841c1f306118461a44ced8907b75d7d94f3114d.png",
  ],
  priceDollars: 14.55,
  description:
    "Do you have a need for custom prints for your shop?  Look no further!  We can create graphics for you or you can send us your existing art. We can also use our existing graphics but add your store or city name underneath to personalize.  We can silk screen most one color prints!  We most commonly sell state themed, or custom verbiage and logos but message us for any questions! We can also provide a mock up before printing.\n\nRabbit Skins Fine Jersey Tee:: \nFabrication: 4.5 oz. 100% combed ringspun cotton fine jersey • Heather is 90/10 combed ringspun cotton/polyester .  EasyTear™ label\n\n*Items are silk screen printed with water based ink. \n\n *If you'd like other colored tees or a different brand shirt, please inquire and we can send more options!\n",
  tags: [],
  msrpDollars: 29.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:18.208Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
